import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex item-name-area" }
const _hoisted_2 = { class: "product-name flex items-center" }
const _hoisted_3 = { class: "img-container emphable-img" }
const _hoisted_4 = { class: "supplier-bottoms-area flex items-end justify-between mt-1" }

import AtomImage from '../images/AtomImage.vue';

// 検索結果interface
interface Result {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}

interface Props {
  // 検索結果
  result: Result;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SimilarCard',
  props: {
    result: {}
  },
  emits: ["onSimilerDetail"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const simResuldDataDetail = (selectAttoId: string) => {
  emit('onSimilerDetail', selectAttoId);
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('similar-card resultdata-area ' + (props.result ? 'simpro-area' : ''))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(props.result.atto_id), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AtomImage, {
        exatoms: props.result.structure
      }, null, 8, ["exatoms"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_q_btn, {
        color: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (simResuldDataDetail(props.result.atto_id)))
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("詳細")
        ])),
        _: 1
      })
    ])
  ], 2))
}
}

})